import styled, { css } from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

const styledDisabledState = css`
    color: ${colorsPalettes.carbon[200]};
    cursor: not-allowed;

    .SWReactIcons > svg > path {
        fill: ${colorsPalettes.carbon[200]};
    }

    &:hover {
        .SWReactIcons > svg > path {
            fill: ${colorsPalettes.carbon[200]};
        }
    }
`;

export const StyledTutorialCustomWrapper = styled.div<{ isDisabled?: boolean }>`
    display: flex;
    ${mixins.setFontVariant("button", colorsPalettes.blue["400"])};

    ${({ isDisabled }) => isDisabled && styledDisabledState};
`;

export const StyledTutorialButtonWrapper = styled.div<{ isDisabled?: boolean }>`
    button.Button {
        &:hover {
            .SWReactIcons > svg > path {
                fill: ${colorsPalettes.blue[400]};
            }
        }

        .SWReactIcons > svg > path {
            fill: ${colorsPalettes.blue[400]};
        }

        ${({ isDisabled }) => isDisabled && styledDisabledState};
    }
`;
